module.exports = __webpack_public_path__ + "static/media/frontID.e8a075b2.svg";